import { useState, useRef, useEffect } from "react";
import { getData } from "../../../ApiServices/ApiService";
import { ORG_GET_CALENDER_LIST } from "../../../ApiServices/BaseURL";
import { convertGMTToLocal } from "../../../Utils/Validation";
import { useTheme } from "../../../GlobalContext/GlobalContext";

const ScheduleRemindersController = () => {
  const [filteredSchedules, setFilteredSchedules] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setIsLoginPopup } = useTheme();
  // useEffect(() => {
  //   fetchSchedulesList();
  // }, []);

  const fetchSchedulesList = async (month_id,year_id) => {
    try {
      setFilteredSchedules({});
      setLoading(true);

      const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));

      // Get current month and year
      const currentDate = new Date();
      // const month_id = currentDate.getMonth() + 1; // JavaScript months are 0-based, add 1
      // const year_id = currentDate.getFullYear();

      // API call with current month and year
      const response = await getData(
        `${ORG_GET_CALENDER_LIST}?emp_id_auth=${storedUserInfo?.emp_id}&month_id=${month_id}&year_id=${year_id}`
      );
      const responseData = await response.json();

      if (response?.status === 200 && responseData?.statusCode === 200) {
        if (responseData?.message.toLowerCase() === "success") {
          if (responseData?.dataJ?.length > 0) {
            const formattedSchedules = formatSchedules(responseData.dataJ);
            setFilteredSchedules(formattedSchedules);
            console.log('formattedSchedules:-------',formattedSchedules)
          } else {
            setError(responseData?.info || "Data Not Found");
          }
        } else {
          setError(responseData?.info || "Failed to fetch schedules data.");
        }
      } else {
        handleErrorResponse(response, responseData);
      }
    } catch (error) {
      handleNetworkError(error);
    } finally {
      setLoading(false);
    }
  };

  const formatSchedules = (data) => {
    const formatted = {};

    data.forEach((item) => {
      const [date, time] = convertGMTToLocal(item.sc_time,'yyyy-MM-dd HH:mm:ss').split(" ");
      const formattedTime = new Date(`2024-01-01T${time}`).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      if (!formatted[date]) {
        formatted[date] = [];
      }

      formatted[date].push({
        time: formattedTime,
        title: item.sc_title,
        sc_desc: item.sc_desc,
        sc_status: item.sc_status,
        sc_location: item.sc_location,
        sc_status_name: item.sc_status_name,
      });
    });

    return formatted;
  };

  const handleErrorResponse = (response, responseData) => {
    if ([400, 401, 403].includes(response?.status)) {
      setError(
        responseData?.info ||
          "Unauthorized access. Your session may have expired. Please log in again."
      );
      setIsLoginPopup(true)
    } else if (response?.status === 500) {
      setError(responseData?.info || "Internal Server Error. Please try again later.");
    } else {
      setError("Unexpected error occurred. Please try again later.");
    }
  };

  const handleNetworkError = (error) => {
    if (error.response) {
      setError(
        `Error: ${error.response.status}. ${
          error.response.data?.message || "Failed to fetch data. Please try again."
        }`
      );
    } else if (error.request) {
      setError(
        "No response received from the server. Please check your network connection and try again."
      );
    } else {
      setError("Failed to fetch data. Please check your network connection and try again.");
    }
  };
  
  const getStatusStyle = (status) => {
    const statusName = status?.toLowerCase();
    switch (statusName) {
      case "new":
        return { backgroundColor: "#0EA5E91A", color: "#0369A1",borderLeft: '3px solid #0369A1' }; // New: Light Teal with Blue text
      case "in-progress":
        return { backgroundColor: "#10B9811A", color: "#047857",borderLeft: '3px solid #047857' }; // In Progress: Light Green with Dark Green text
        case "completed":
        return { backgroundColor: "#8B5CF61A", color: "#6D28D9",borderLeft: '3px solid #6D28D9' }; // Completed: Light Violet with Purple text
      case "overdue":
        return { backgroundColor: "#FFE4E6", color: "#BE123C",borderLeft: '3px solid #BE123C' }; // Overdue: Light Red with Dark Red text
      case "start in 1 hour":
        return { backgroundColor: "#E2B1332E", color: "#DFA510",borderLeft: '3px solid #DFA510' }; // Starts in One Hour: Light Orange with Dark Orange text
      case "reschedule":
        return { backgroundColor: "#F59E0B1A", color: "#B45309",borderLeft: '3px solid #B45309' }; // Reschedule: Same as "Starts in One Hour" (Dark Orange)
      case "attended":
        return { backgroundColor: "#8B5CF61A", color: "#6D28D9",borderLeft: '3px solid #6D28D9' }; // Reschedule: Same as "Starts in One Hour" (Dark Orange)
      case "not attended":
        return { backgroundColor: "#E6E8EC", color: "#000",borderLeft: '3px solid #000' }; // Reschedule: Same as "Starts in One Hour" (Dark Orange)
  
      
      default:
        return { backgroundColor: "#FFFFFF", color: "#000" ,borderLeft: '3px solid #000'}; // Default to white with black text if no status matches
    }
  };




  return {
    filteredSchedules,
    loading,
    error,
    fetchSchedulesList,
    getStatusStyle
  };
};

export default ScheduleRemindersController;
